export default __webpack_public_path__ + "static/media/commerce.47924a5f.png";